import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Paper } from '@mui/material';
import React from 'react';
import { useGenerateEmailPreview } from '../../../../services/react-query/email_templates/useGenerateEmailPreview';
import { useGetEmployeeById } from '../../../../services/react-query/employees';
import { Contact } from '../../../../types/Contact';
import { EmailTemplateLink, EmailTemplateRecipientsType } from '../../../../types/EmailTemplate';
import { editPreviewModalStyles } from './editPreviewModalStyles';
import { modalStyles } from '../common/commonStyles';
import EmailSendForm from './EmailSendForm';
import EmailBodyView from '../common/EmailBodyView';

interface EmailPreviewModalProps {
  open: boolean;
  onClose: () => void;
  eventContacts: Contact[];
  selectedTemplate: EmailTemplateLink;
}

const EmailPreviewModal: React.FC<EmailPreviewModalProps> = ({ open, onClose, selectedTemplate, eventContacts }) => {
  const { uuid: eventEmailTemplateUuid } = selectedTemplate;
  const { data: currentEmployeeData } = useGetEmployeeById({ uuid: 'current' });
  const { data, isLoading, isError } = useGenerateEmailPreview({
    eventEmailTemplateUuid,
    recipientType: EmailTemplateRecipientsType.EMPLOYEE,
    recipientUuid: currentEmployeeData?.uuid || '',
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle sx={modalStyles.dialogTitle}>Email Preview</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Box sx={modalStyles.loadingBox}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Box sx={modalStyles.errorBox}>Failed to load preview.</Box>
        ) : (
          <Box sx={modalStyles.container}>
            <Box sx={editPreviewModalStyles.subjectBox}>
              <strong>Subject:</strong> {data.subject}
            </Box>

            <EmailBodyView body={data.body} />

            <Paper sx={editPreviewModalStyles.sendFormWrapper}>
              <EmailSendForm eventEmailTemplateUuid={eventEmailTemplateUuid} eventContacts={eventContacts} />
            </Paper>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailPreviewModal;
